import ucenter_request from '@/utils/ucenter_request.js'
import edu_request from '@/utils/edu_request'
import qs from 'qs'

// 英语老师-获取token
export function getAiEnToken(params) {
  return ucenter_request({
    url: 'api/aiv2/getAiEnToken',
    method: 'POST',
    params: params
  })
}

// 文字识别
export function getAiResultByPhoto(params) {
  return edu_request({
    url: '/subject/Zkbpro/getAiResultByPhoto',
    method: 'post',
    data: qs.stringify(params)
  })
}
